const TENANT_SCROLL_OWNER_SELECTOR = '[data-tenant-scroll-owner]';

export function tenantRouteScrollKey(route = {}) {
  const path = [route.name || 'home', ...(Array.isArray(route.rest) ? route.rest : [])]
    .map((segment) => encodeURIComponent(String(segment)))
    .join('/');
  const query = new URLSearchParams();
  for (const [key, value] of Object.entries(route.query || {}).sort(([left], [right]) => (
    left.localeCompare(right)
  ))) {
    query.set(key, String(value));
  }
  const serialized = query.toString();
  return serialized ? `${path}?${serialized}` : path;
}

export function resetTenantScrollOwner(owner, windowLike = globalThis.window) {
  const documentLike = windowLike?.document || globalThis.document;
  const scrollContainers = [
    owner,
    documentLike?.documentElement,
    documentLike?.body,
    documentLike?.getElementById?.('root'),
  ];
  for (const container of new Set(scrollContainers.filter(Boolean))) {
    container.scrollTop = 0;
    container.scrollLeft = 0;
  }
  if (windowLike && (windowLike.scrollX || windowLike.scrollY)) {
    windowLike.scrollTo?.({ top: 0, left: 0, behavior: 'auto' });
  }
}

export function captureTenantViewportAnchor(control) {
  const owner = control?.closest?.(TENANT_SCROLL_OWNER_SELECTOR) || null;
  const anchor = control?.closest?.('label') || control || null;
  if (!owner || !anchor?.getBoundingClientRect) return null;
  return Object.freeze({
    owner,
    anchor,
    control,
    ownerScrollTop: owner.scrollTop,
    anchorTop: anchor.getBoundingClientRect().top,
    restoreFocus: control?.ownerDocument?.activeElement === control,
  });
}

export function restoreTenantViewportAnchor(snapshot) {
  if (!snapshot?.owner || snapshot.owner.isConnected === false) return;
  const { owner, anchor, control, ownerScrollTop, anchorTop, restoreFocus } = snapshot;
  if (anchor?.isConnected !== false && anchor?.getBoundingClientRect) {
    const nextTop = anchor.getBoundingClientRect().top;
    owner.scrollTop = ownerScrollTop + (nextTop - anchorTop);
  } else {
    owner.scrollTop = ownerScrollTop;
  }
  if (restoreFocus && control?.isConnected !== false) {
    control.focus?.({ preventScroll: true });
  }
}

export function scrollCampaignStepIntoView({
  owner,
  navigation,
  heading,
  inset = 12,
} = {}) {
  if (!owner || owner.isConnected === false || !navigation?.getBoundingClientRect) return;
  const ownerTop = owner.getBoundingClientRect?.().top || 0;
  const navigationTop = navigation.getBoundingClientRect().top;
  owner.scrollTop = Math.max(0, owner.scrollTop + navigationTop - ownerTop - inset);
  if (heading?.isConnected !== false) heading?.focus?.({ preventScroll: true });
}
